/* Utilities */
import _ from 'lodash'

import {
  PUSH,
  PULL,
  UPDATE
} from 'react-redux/actions/notification'

import { RESET } from 'react-redux/actions/app'

const initialState = {
  list: {
  items: {},
  filter: ""
  }
}

export default (state = initialState, action) => {
  switch (action.type) {
    case RESET: {
      return _.cloneDeep(initialState)
    }
    case PUSH: {
      let list = _.cloneDeep(state.list)
      list.items[action.notification.uid] = action.notification
      list.items[action.notification.uid].created = Date.now()
      list.items[action.notification.uid].stacked = true
      return Object.assign({}, state, { list })
    }
    case UPDATE: {
      let list = _.cloneDeep(state.list)
      list.items[action.notification.uid] = Object.assign({}, list.items[action.notification.uid], action.notification)
      list.items[action.notification.uid].changed = Date.now()
      //list.items[action.notification.uid].stacked = true
      return Object.assign({}, state, { list })
    }
    case PULL: {
      let list = _.cloneDeep(state.list)
      if(list.items[action.notification.uid]) {
        list.items[action.notification.uid].stacked = false
      }
      return Object.assign({}, state, { list })
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/app/react-redux/reducers/notification.js